import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { VALUES, STATS, BOOKING_URL } from "@/data/site";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="pt-16 pb-20 md:pt-24 md:pb-28 border-b border-[#E5E5E5]">
        <div className="container-cc">
          <div className="overline mb-8"><span className="kicker-line" />About CraftCulture</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] max-w-5xl">
            We're not an events company. We're the <span className="italic text-[#A60201]">strategic culture partner</span> for forward-looking HR teams.
          </h1>
          <p className="mt-10 text-lg text-[#525252] max-w-2xl leading-relaxed">
            CraftCulture began with a quiet conviction: that culture deserves the same rigor as strategy. We build employee experience programs, cultural IPs and engagement interventions for the world's most people-first organizations.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-cc grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img src="https://images.pexels.com/photos/3862154/pexels-photo-3862154.jpeg" alt="Team in discussion" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="overline mb-5"><span className="kicker-line" />Founder Note</div>
            <h2 className="font-serif-display text-3xl md:text-4xl leading-tight">"We built CraftCulture for the HR leader who has been asked to make culture measurable — without losing its soul."</h2>
            <div className="mt-8 space-y-5 text-[#525252] text-base leading-relaxed">
              <p>After a decade inside global HR teams and culture consultancies, our founding team kept seeing the same gap. Strategy decks rarely translated into employee experiences employees actually remembered. And events agencies, however polished, could not be trusted with cultural nuance.</p>
              <p>CraftCulture was built to live in that gap — bringing the rigor of consulting, the taste of a studio, and the discipline of an operations partner to every program we touch.</p>
            </div>
            <div className="mt-8 text-sm font-semibold">— Founding team, CraftCulture</div>
          </div>
        </div>
      </section>

      <section className="section bg-white border-y border-[#E5E5E5]">
        <div className="container-cc grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <div className="overline mb-5"><span className="kicker-line" />Mission</div>
            <h3 className="font-serif-display text-3xl md:text-4xl leading-tight">To help organizations build workplaces employees love belonging to.</h3>
          </div>
          <div>
            <div className="overline mb-5"><span className="kicker-line" />Vision</div>
            <h3 className="font-serif-display text-3xl md:text-4xl leading-tight">To become the world's most trusted employee experience platform — the preferred third arm for HR and leadership teams globally.</h3>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="overline mb-6"><span className="kicker-line" />What we believe</div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-tight max-w-3xl mb-14">Four values that quietly shape every decision we make.</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
            {VALUES.map((v, i) => (
              <div key={i} data-testid={`value-${i}`} className="bg-[#FAFAFA] p-8 lg:p-10">
                <div className="font-serif-display text-3xl">{v.title}</div>
                <div className="mt-4 text-[#525252] leading-relaxed">{v.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-[#0A0A0A] text-white">
        <div className="container-cc">
          <div className="overline text-white/60 mb-6"><span className="kicker-line" />Our journey</div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {STATS.map((s, i) => (
              <div key={i} className="bg-[#0A0A0A] p-8">
                <div className="font-serif-display text-5xl text-[#FEBE98]">{s.value}</div>
                <div className="mt-3 text-sm text-white/70">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="bg-[#FEBE98] p-10 md:p-16">
            <h2 className="font-serif-display text-3xl md:text-5xl leading-tight max-w-3xl">Want to explore a partnership?</h2>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-primary" data-testid="about-book-call">Book Discovery Call <ArrowUpRight size={16} /></a>
              <Link to="/contact" className="btn-secondary" data-testid="about-contact-link">Send us a brief</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
